import { SelectProps } from 'antd';
import { useEffect, useState } from 'react';

import { SelectInput, CheckboxInput } from '@thinknet-gmbh/platform-common-ui';
import { ClientsSelectStyledInput } from '../../../../salary-types.styles';

interface IOption {
  label: string;
  value: string;
  company?: string;
  location?: string;
}

const ClientsSelect = ({
  optionData,
  ...props
}: SelectProps<any> & {
  optionData: { _id?: string; company?: string; location?: string; datevNumber?: string }[];
}) => {

  const options = optionData.map(({ company, location, _id, datevNumber }) => ({
    label: datevNumber || '',
    value: _id || '',
    company,
    location,
  }));

  const [optionValue, setOptionValue] = useState<IOption>({} as IOption);

  useEffect(() => {
    if (props.value) {
      const values = props.value.map((value: any) => ({ [value]: true }));

      setOptionValue(Object.assign({}, ...values));
    }
  }, [props.value]);

  return (
    <ClientsSelectStyledInput
      {...props}
      mode="multiple"
      showArrow={true}
      tagRender={props => {
        // @ts-ignore
        const labelEl =  props.label![1]
        const label = labelEl.split('-')
        return label[0]
      }}
      onSelect={value => setOptionValue(oldValue => ({ ...oldValue, [value]: true }))}
      onDeselect={value => setOptionValue(oldValue => ({ ...oldValue, [value]: false }))}
    >
      {options.map((item: IOption, index) => {
        const {value, label, location, company} = item
        // @ts-ignore
        const checked = optionValue[value];
        return (
          <SelectInput.Option value={value} key={index}>
            <CheckboxInput checked={checked} />
            {`${label}-${company}-${location}`}
          </SelectInput.Option>
        );
      })}
    </ClientsSelectStyledInput>
  );
};

export default ClientsSelect;
